export type NameModals =
  | "saveConfig"
  | "loader"
  | "glbLoader"
  | "renderLoader"
  | "renderPreview"
  | "fullScreenPreview"
  | "pleaseNote"
  | "serverOffline"
  | "createFolderModal"
  | "createTemplateModal"
  | "createPresetModal"
  | "sceneHint"
  | "resetScene";

export type ModalStatusT = {
  isShow: boolean;
  otherParams?: any;
};

export type modalsListT = Record<NameModals, ModalStatusT>;

export enum EInterfaceContent {
  Tabs = "tabs",
  EnvironmentItem = "environmentItem",
  ObjectItem = "objectItem",
}

export enum EServerStatus {
  Offline = "offline",
  Online = "online",
  Pending = "pending",
}

export interface IInnerLoaders {
  [key: string]: boolean;
}
